import { NAVIGATION_COPY } from '@/locales/en'
import { getAddressString } from '@/common/utils/utils'
import type { AccountParticipantListItem } from '@/account/type'
import type { DetailItem } from '../types'

const EMPTY_VALUE = '-'

const formatAULocalMobile = (mobile: string) => {
    const digitsOnly = mobile.replace(/\D/g, '')
    if (!/^0\d{9}$/.test(digitsOnly)) return mobile

    return `${digitsOnly.slice(0, 4)} ${digitsOnly.slice(4, 7)} ${digitsOnly.slice(7, 10)}`
}

const formatMobileForPersonalDetails = (mobile: string | undefined) => {
    if (!mobile) return EMPTY_VALUE

    const trimmed = mobile.trim()
    if (/^\+61/.test(trimmed)) {
        const localMobile = trimmed.replace(/^\+61\s?/, '')
        const normalizedLocal = localMobile.startsWith('0') ? localMobile : `0${localMobile}`
        return formatAULocalMobile(normalizedLocal)
    }

    return trimmed
}

export const buildAccountHolderDetailItems = (participant: AccountParticipantListItem): DetailItem[] => {
    const copy = NAVIGATION_COPY.account

    const fullName = [participant.firstName, participant.middleName, participant.lastName]
        .filter(Boolean)
        .join(' ')
        .trim()
    return [
        { key: 'name', label: copy.fields.name, value: fullName || EMPTY_VALUE },
        { key: 'email', label: copy.fields.email, value: participant.email || EMPTY_VALUE },
        {
            key: 'mobile',
            label: copy.fields.mobileNumber,
            value: participant.mobile ? formatMobileForPersonalDetails(participant.mobile) : EMPTY_VALUE,
        },
        {
            key: 'address',
            label: copy.fields.address,
            value: participant.address ? getAddressString(participant.address) : EMPTY_VALUE,
        },
        {
            key: 'postalAddress',
            label: copy.fields.postalAddress,
            value: participant.postalAddress ? getAddressString(participant.postalAddress) : EMPTY_VALUE,
        },
        { key: 'role', label: copy.fields.accessType, value: participant.accessProfile || EMPTY_VALUE },
    ]
}
